<div class="container" (keyup.enter)="showCountDownSecond ? handleOrder() : relockPrice()">
  <div class="close" (click)="closeDialog(false)">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <h1 class="title">Confirmar {{ data.operation === 'BUY' ? 'compra' : 'venta' }}</h1>

  <div class="bundle-info">
    <img [src]="'/assets/icons/crypto/bundles/' + data.ticker + '.svg'" alt="" class="icon" />
    <p class="name">{{ data.name }}</p>
  </div>

  <div class="operation-info">
    <div class="total">
      <p class="text">Total</p>
      <p class="amount">
        {{ data.currency.replace('S', '$') }}
        {{ data.fiatAmount | formatCoinAmount: data.currency }} {{ data.coin }}
      </p>
    </div>
    <div class="separator"></div>
    <div class="rate">
      <p class="text">Cotizaciones</p>
      <div class="summary">
        <div class="item" *ngFor="let coin of data.coinsTickers">
          <p class="name">{{ coin.split('_')[0] }}</p>
          <p class="price">
            {{ data.currency.replace('S', '$') }}
            {{ +data.lockedBundle.locks[coin].price | formatCoinAmount: data.currency }}
          </p>
          <p class="value">
            {{ getCoinQuantity(coin) | formatCoinAmount: coin.split('_')[0] }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="buttons">
    <button
      *ngIf="!isProcessing"
      class="td-btn"
      [class.disabled]="!firstLockBundleDone"
      (click)="showCountDownSecond ? handleOrder() : relockPrice()"
    >
      {{ firstLockBundleDone ? data.options[0] : 'Obteniendo precio' }}
    </button>
    <div class="loading" *ngIf="isProcessing">
      <div class="circle-loader">
        <div class="checkmark draw"></div>
      </div>
    </div>
  </div>

  <p class="price-timer" *ngIf="showCountDownSecond && !this.isProcessing">
    Cotizaciones válidas por {{ countDownSecond }}s
  </p>
  <p class="price-timer" *ngIf="firstLockBundleDone && !showCountDownSecond && !this.isProcessing">
    Oferta caducada
  </p>
</div>
